import cn from "classnames";
import { memo, useState } from "react";
import { canv } from "@/canv/global";
import { Button } from "@/shared/ui/Button";
import { HStack } from "@/shared/ui/Stack";
import { FIRST_SHAPES } from "../../constants/firstShapes";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./ShapeMenu.module.css";

interface ShapeMenuContentProps {
    onShapeButtonClick: (shape: string) => void;
}

export const ShapeMenuContent = memo(function ShapeMenuContent({
    onShapeButtonClick,
}: ShapeMenuContentProps) {
    const [shapes, setShapes] = useState(FIRST_SHAPES);

    const handleMoreButtonClick = () => {
        setShapes(canv.shapeStorage.getAllShapes());
    };

    const isScrollable = shapes.length !== FIRST_SHAPES.length;

    const wrapperStyles = cn(styles.wrapper, isScrollable && "scrollable");

    return (
        <HStack className={wrapperStyles} wrap="wrap" gap={4}>
            {shapes.map((shapeName) => {
                const shapeIcon = canv.shapeStorage.getShape(shapeName).getView();

                return (
                    <MenuButton
                        key={shapeName}
                        onClick={() => onShapeButtonClick(shapeName)}
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: <Вставляются инлайн-свг из шейпов>
                        dangerouslySetInnerHTML={{ __html: shapeIcon }}
                    />
                );
            })}
            {shapes.length === FIRST_SHAPES.length && (
                <Button variant="tertriary" onClick={handleMoreButtonClick} fullWidth>
                    +
                </Button>
            )}
        </HStack>
    );
});
